import { Switch } from "@/components/ui/switch";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";
import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value: boolean;
  onChange?: (value: boolean) => void;
  trueLabel?: string;
  falseLabel?: string;
};

/**
 * Card-based Form / SwitchItem
 */
export const CFormSwitchItem = buildCFormItem((props: Props) => {
  const tc = useCommonTranslation();

  return (
    <CFormItemBase
      {...props}
      readComponent={
        props.value
          ? (props.trueLabel ?? tc("hasValue"))
          : (props.falseLabel ?? tc("hasNoValue"))
      }
      writeComponent={
        <Switch
          checked={props.value}
          onCheckedChange={(checked) => props.onChange?.(checked)}
          disabled={props.readonly}
        />
      }
    />
  );
});
